module.exports = __webpack_public_path__ + "media/brand/sprite-5c35e7cd.svg";